<template lang="pug">
v-dialog(v-model='dialog' width='800' persistent)
    v-overlay(:value='cargando_')
        v-progress-circular(indeterminate size="100") 
            span Espere
    template( v-slot:activator='{on}')
        v-btn(v-if='se_envia_a_todos' color='light-green accent-4' @click='dialog = true' dark ) 
            v-icon(left) fas fa-paper-plane
            span Enviar mensaje a todos
        div(v-else)
            v-tooltip(top)
                template(v-slot:activator='{on}')
                    v-btn(color='light-green accent-4' @click='dialog = true' dark icon) 
                        v-icon  fas fa-envelope
                span Enviar mensaje a {{correo}}
    v-card
        v-card-title.ma-0.light-green.accent-4
            h4(v-if='se_envia_a_todos').white--text Mensaje para todos
            h4(v-else).white--text Mensaje para {{correo}}
            v-spacer
            v-btn(icon @click='cerrar()' dark)
                v-icon fas fa-times
        v-card-text
            v-container
                v-form(v-model='validación')
                    v-text-field(:rules='[Reglas.required]' filled color='green ligthen-2' label='Asunto' rounded  v-model='Mensaje.asunto' solo)
                    v-text-field(:rules='[Reglas.required]' filled color='green ligthen-2' label='Título' rounded  v-model='Mensaje.título' solo)
                    v-textarea(:rules='[Reglas.required]' filled color='green ligthen-2' label='Mensaje' rounded  v-model='Mensaje.cuerpo' solo)
               
        v-card-actions
            v-row.justify-center
                v-btn(dark color='green ligthen-2' @click='enviar()' :dark='validación' :disabled='!validación') Enviar
        
</template>
<script>
import { mapMutations, mapActions, mapState } from 'vuex'
export default {
    data: ()=>({
        validación: true,
        dialog: false,
        cargando_: false,
    }),
    methods: {
        ...mapActions({
            enviar_correo: 'Mensaje/enviar_correo',
            enviar_correo_a_todos: 'Mensaje/enviar_correo_a_todos',
        }),
        ...mapMutations({
            limpiar_mensaje: 'Mensaje/limpiar_mensaje'
        }),
        cerrar(){
            this.dialog = false
            this.limpiar_mensaje()
        },
        async enviar(){
            this.cargando_=true
            if(this.se_envia_a_todos) await this.enviar_correo_a_todos()
            else await this.enviar_correo(this.correo)
            this.cargando_=false
            this.cerrar()
        },
    },
    computed: {
        ...mapState({
            Mensaje: ({Mensaje})=>Mensaje.mensaje,
            Reglas: ({Ayudas})=>Ayudas.reglas,
        }),
    },
    props: {
        correo: String,
        se_envia_a_todos: Boolean,
    },
}
</script>